import React from 'react'
import { Radio, Menu, Select } from 'antd'
import API from '../../services/API'

const StatusColumnFilter = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    route = '',
    options = [],
    refInput
}) => {
    const [data, setData] = React.useState([]);
    const handleClick = (e) => {
        const key = e.key;
        setSelectedKeys([key]);
        confirm();
    };

    const getData = () => {
        API.get(`${route}?pagination=false`)
            .then(response => {
                if (response) {
                    setData(response.data);
                }
            }).catch(error => {
                console.error(error.response ? error.response.data : error.message);
            })
    }

    React.useEffect(() => {
        if(options.length>0){
            setData(options);
            return;
        }
        getData();
    }, []);

    return (
        <Menu mode="vertical"
         style={{ borderRight: 'unset' }}
         onClick={handleClick}
         selectedKeys={[selectedKeys[0]]}
         ref={(node) => {
            refInput.current = node;
         }}>
            {data.length > 0 ? data.map(d => (
                <Menu.Item key={d.id} value={d.id}>
                    {d.name}
                </Menu.Item>
            )) : null}
        </Menu>
    )
}
export default StatusColumnFilter;
